import * as Collapsible from "@radix-ui/react-collapsible";
import { ChevronDown } from "lucide-react";

/**
 * `relative z-[1]` keeps the trigger above a card's stretched-link ::after,
 * which would otherwise swallow its clicks. 1 and not 10, so it still passes
 * under the sticky header.
 */
export default function LearnMore({
  label,
  paragraphs = [],
  bullets = [],
  centered = false,
}) {
  if (paragraphs.length === 0 && bullets.length === 0) {
    return null;
  }

  return (
    <Collapsible.Root className="relative z-[1] w-full">
      <Collapsible.Trigger
        className={`group flex w-full items-center gap-1 rounded text-sm sm:text-base font-semibold text-[#3387CF] hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3387CF] focus-visible:ring-offset-2 ${
          centered ? "justify-center" : ""
        }`}
      >
        {label}
        <ChevronDown className="h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-180" />
      </Collapsible.Trigger>

      <Collapsible.Content
        className={`pt-1 text-sm sm:text-base text-[#555555] ${centered ? "text-center" : ""}`}
      >
        {paragraphs.map((paragraph, index) => {
          // A paragraph is a string or `{ lead, text }` (bold run-in heading).
          const { lead, text } =
            typeof paragraph === "string" ? { text: paragraph } : paragraph;

          return (
            <p key={index} className="m-0 mt-2">
              {lead && (
                <strong className="font-semibold text-[#1E2D3D]">
                  {lead}:{" "}
                </strong>
              )}
              {text}
            </p>
          );
        })}

        {bullets.length > 0 && (
          <ul
            className={`m-0 mt-2 flex list-disc flex-col gap-1.5 ${
              centered ? "list-inside pl-0" : "pl-5"
            }`}
          >
            {bullets.map((bullet, index) => (
              <li key={index}>{bullet}</li>
            ))}
          </ul>
        )}
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
